import { events } from '@otto-ec/global-resources/event-q-bus';
import { log } from '@shared/log.browser.ts';
import { isSponsoredProduct } from '@shared/types/types';
import type { FirebaseTracking } from '@tilelist/application/ports/FirebaseTracking.ts';
import { type TileListItem, isProductItem } from '@tilelist/domain/composition/TileListitem.ts';

const MAX_ITEMS_TO_TRACK = 5;

type FirebaseTrackingTopics = {
    'ft-apps.firebase.eventTracking': [{ event_name: 'view_item'; event_params: { item_id: string } }];
};

export function createFirebaseTracking(): FirebaseTracking {
    const bus = events<FirebaseTrackingTopics>();
    return {
        trackProductView(itemId) {
            bus.emit('ft-apps.firebase.eventTracking', {
                event_name: 'view_item',
                event_params: { item_id: itemId },
            });
        },
    };
}

export function trackFirebase(tracking: FirebaseTracking, tileListItems: TileListItem[]): void {
    const productItemsToTrack = tileListItems
        .filter(isProductItem)
        .filter(({ product }) => !isSponsoredProduct(product))
        .slice(0, MAX_ITEMS_TO_TRACK);

    for (const productItem of productItemsToTrack) {
        const item_id = productItem.product.articleNumber ?? 'UNKNOWN';

        log.debug(
            `Firebase Tracking: item_id:${item_id}, localListPosition: ${productItem.localListPosition}, productType: ${productItem.product.productType}`,
        );
        tracking.trackProductView(item_id);
    }
}
